export const TITLE_MAX_LENGTH = 50;

/** Copy shown on an uploaded-file chip that's still uploading. */
export const UPLOAD_FILE_STATUS_UPLOADING = 'Uploading…';
/** Copy shown on an uploaded-file chip while content extraction is running. */
export const UPLOAD_FILE_STATUS_PROCESSING = 'Processing…';
/** Copy shown on an uploaded-file chip whose upload/processing has failed. */
export const UPLOAD_FILE_ERROR_LABEL = 'Error';
/** Fallback copy for the hover tooltip when a chip is in an error state but has no message. */
export const UPLOAD_FILE_ERROR_TOOLTIP_FALLBACK = 'Error';
/** Tooltip on a chip whose file the malware scan flagged. */
export const UPLOAD_FILE_INFECTED_ERROR = "This file didn't pass the virus scan, so it can't be used.";
/** Tooltip on a chip whose file never got a malware-scan verdict. */
export const UPLOAD_FILE_SCAN_FAILED_ERROR =
  "This file couldn't be scanned for viruses. Remove it and upload it again.";
/** Copy shown for the toast when the recent-chats list on the case page fails to load. */
export const RECENT_CASE_CHATS_LOAD_ERROR = 'Failed to load recent chats';

/** Marks controls that put a prompt in the chat box, so pressing them doesn't collapse the box first. */
export const KEEPS_CHAT_INPUT_OPEN_ATTR = 'data-keeps-chat-input-open';
